export default __webpack_public_path__ + "static/media/rupee_currency.07ddcc59.svg";